import React from 'react';
import { Redirect, Route, Switch, useHistory } from 'react-router-dom';
import makeStyles from '@material-ui/core/styles/makeStyles';
import classNames from 'classnames';
import { AuthState } from '@aws-amplify/ui-components';
import { Routing } from '../../../../global';
import {
  ThankYouPage,
  ThankYouPageDescription,
  ThankYouPageHomeLink,
  ThankYouPageTitle,
  ThankYouPageWrapper,
} from '../../../../routes/thank-you';
import { useAuth } from '../auth/auth';

const AdminPage = React.lazy(() => import('../../../../routes/admin'));
const BuyProcessPage = React.lazy(
  () => import('../../../../routes/buy-process-page'),
);
const SellOfferPage = React.lazy(
  () => import('../../../../routes/sell-process'),
);

// Need 2 different styles for authenticated and unauthenticated because
// they have different headers.
const useStyles = makeStyles(() => ({
  unAuthenticatedStyles: {
    maxWidth: '1300px',
    margin: '0 auto',
    minHeight: 'calc(100vh - 150px)',
    paddingTop: '32px',
    paddingBottom: '32px',
    paddingLeft: '16px',
    paddingRight: '16px',
  },

  authenticatedStyles: {
    maxWidth: '1300px',
    margin: '0 auto',
    minHeight: 'calc(100vh - 72px)',
    paddingTop: '128px',
    paddingBottom: '32px',
    paddingLeft: '16px',
    paddingRight: '16px',
  },
}));

export const Routes = () => {
  const classes = useStyles();
  const auth = useAuth();

  const { listen } = useHistory();

  React.useEffect(
    () =>
      listen((location) => {
        // @ts-ignore
        if (window.gtag) {
          // @ts-ignore
          window.gtag('config', 'UA-51176136-6', {
            page_path: location.pathname,
          });
        }
      }),
    [listen],
  );

  return (
    <div
      className={classNames({
        [classes.unAuthenticatedStyles]: auth.authState === AuthState.SignedOut,
        [classes.authenticatedStyles]: auth.authState === AuthState.SignedIn,
      })}
    >
      <Switch>
        <Route path={Routing.BuyProcess} component={BuyProcessPage} />

        <Route path={Routing.SellOfferCreate} component={SellOfferPage} />

        <Route path={Routing.AdminPanel.Default} component={AdminPage} />

        <Route path={Routing.ThankYou} component={ThankYouPage} />

        <Route path={Routing.ThankYouSellOffer}>
          <ThankYouPageWrapper>
            <ThankYouPageTitle>Tack för er offertförfrågan</ThankYouPageTitle>

            <ThankYouPageDescription>
              Vi återkopplar inom två timmar med er offert.
            </ThankYouPageDescription>

            <ThankYouPageHomeLink />
          </ThankYouPageWrapper>
        </Route>

        {auth.authState === AuthState.SignedIn ? null : (
          <Redirect to={Routing.BuyProcess} />
        )}
      </Switch>
    </div>
  );
};
